import { isValidPhoneNumber } from "libphonenumber-js";
import i18n from "i18next";
export function isEmailValid(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function parseNullItem(data) {
  data = { ...data };
  Object.keys(data).map((key) => {
    if (data[key] === null || data[key] === "null") {
      delete data[key];
    }
    return null;
  });
  return data;
}

export function isPhoneValid(phone) {
  return /^[\+1]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(
    phone
  );
}

export function isURLValid(url) {
  return /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi.test(
    url
  );
}

export function validateRequired(text) {
  if (!isNaN(text)) {
    text = text.toString();
  }
  if (text.trim() === "") {
    return "ERROR_MESSAGES.This_field_is_required";
  }
  return false;
}

export function validatePhoneWithRequired(text) {
  if (text != undefined) {
    if (text.trim() === "") {
      return "ERROR_MESSAGES.This_field_is_required";
    } else {
      if (!isValidPhoneNumber(text, "US")) {
        return "ERROR_MESSAGES.Cell_Phone_Must_Be_Valid";
      }
    }
  } else {
    return "ERROR_MESSAGES.This_field_is_required";
  }
  return false;
}

export function validateNameWithRequired(text) {
  if (text != undefined) {
    let pattern = /^[ A-Za-z0-9_@./#&+-]*$/;
    if (text.trim() === "") {
      return "ERROR_MESSAGES.Name_is_Required";
    } else if (!pattern.test(text)) {
      return "ERROR_MESSAGES.Name_Must_Be_Valid";
    }
  } else {
    return "ERROR_MESSAGES.Name_is_Required";
  }
  return false;
}

export function validateTextWithRequired(text) {
  if (text != undefined) {
    let pattern = /^[A-Za-z\s]+$/;
    if (text.trim() === "") {
      return "ERROR_MESSAGES.This_field_is_required";
    } else if (!pattern.test(text)) {
      return "Invalid Text";
    }
  } else {
    return "ERROR_MESSAGES.This_field_is_required";
  }
  return false;
}

export function validateEmailWithRequired(text) {
  if (text != undefined) {
    if (text.trim() === "") {
      return "ERROR_MESSAGES.Email_Must_Be_Valid";
    } else {
      if (!isEmailValid(text)) {
        return "ERROR_MESSAGES.Email_Must_Be_Valid";
      }
    }
  }
  return false;
}

export function validateTextLength(value, limit) {
  let error =
    value.length > limit
      ? `${"ERROR_MESSAGES.Name_must_be"} ${limit} ${"ERROR_MESSAGES.characters_max"}`
      : "";
  value = value.length > limit ? value.substring(0, limit) : value;
  return { value, error };
}
